import { render, staticRenderFns } from "./ReferModal.vue?vue&type=template&id=9cdbb750&scoped=true&"
import script from "./ReferModal.vue?vue&type=script&lang=js&"
export * from "./ReferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdbb750",
  null
  
)

export default component.exports